
import { Reporting } from '../../api/reports/reporting';
import { formatDate, parseDate } from '../../api/dates/date_formatter';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      rangeType: 'created',
      startDate: '',
      startDateFormatted: '',
      endDate: '',
      endDateFormatted: '',

      message: '',
      messageAlert: true
    };
  },
  methods: {
    parseDateInternal(date: string): string {
      return parseDate(date);
    },
    runReport() {
      Reporting.getTeeTimeReport(this.startDate, this.endDate, this.rangeType).then((response) => {
        if (response.data.message) {
          this.messageAlert = true
          this.message = response.data.message
        }
      });
    },
  },
  computed: {
    disableButton(): boolean {
      return !this.startDate || !this.endDate
    }
  },
  watch: {
    startDate() {
      this.startDateFormatted = formatDate(this.startDate);
    },
    endDate() {
      this.endDateFormatted = formatDate(this.endDate);
    },
  },
});
